const promotion = {
  page: {
    opening: "Открытие Центра продвижения",
    loading: "Проверяем сессию и загружаем данные кампаний.",
    notice: "Уведомление",
    errors: {
      settings: "Не удалось загрузить настройки куратора.",
      initialize: "Не удалось инициализировать Центр продвижения.",
    },
  },
  center: {
    campaignWorkspace: "Рабочее пространство кампаний",
    aiStudio: "Студия ИИ-продвижения",
  },
  common: {
    refresh: "Обновить",
    optional: "необязательно",
    unknown: "Неизвестно",
    unknownType: "неизвестный тип",
    unknownBot: "Неизвестный бот",
    unknownChannel: "неизвестно",
    bot: "Бот:",
    roles: { superAdmin: "Super-Admin", admin: "Admin" },
    created: "Создано {{date}}",
    createdBy: "Создано {{date}} пользователем {{username}}",
    startedCompleted: "Начато {{started}} · Завершено {{completed}}",
    checked: "Проверено {{date}}",
    total: "всего {{count}}",
    viewAll: "Показать все",
    cancel: "Отмена",
    delete: "Удалить",
    enable: "Включить",
    disable: "Отключить",
    add: "Добавить",
    status: {
      draft: "Черновик",
      ready: "Готово",
      running: "Выполняется",
      completed: "Завершённые",
      partial: "Частично",
      failed: "Ошибка",
      cancelled: "Отменено",
    },
    contentMode: {
      original: "Оригинал",
      teaser: "Тизер",
      ai: "Подготовлено ИИ",
      custom: "Пользовательский",
    },
    deliveryStatus: {
      pending: "Ожидает",
      in_progress: "В процессе",
      success: "Успешно",
      failed: "Ошибка",
      skipped: "Пропущено",
    },
    chatType: {
      channel: "Канал",
      group: "Группа",
      supergroup: "Супергруппа",
    },
  },
  workspace: {
    loadingTitle: "Загрузка Центра продвижения",
    loadingDescription: "Синхронизируются кампании, цели и история доставки.",
    heroEyebrow: "Центр продвижения",
    heroTitle: "Рабочее пространство распространения кампаний",
    heroDescription: "Преобразуйте собранные публикации в управляемые кампании, доставляйте их в проверенные Telegram-каналы и группы и повторяйте только неудачные назначения.",
    loadErrorTitle: "Не удалось загрузить данные продвижения",
    tabs: {
      overview: "Обзор",
      campaigns: "Кампании",
      create: "Создать кампанию",
      targets: "Цели продвижения",
      history: "История доставки",
    },
    stats: {
      campaigns: "Кампании",
      active: "Активные",
      completed: "Завершённые",
      attention: "Требуют внимания",
    },
    recent: {
      title: "Недавние кампании",
      description: "Последняя активность и состояние кампаний.",
      emptyTitle: "Кампаний пока нет",
      emptyDescription: "Создайте первую кампанию продвижения из собранных публикаций Telegram.",
      create: "Создать кампанию",
    },
    readiness: {
      title: "Готовность целей",
      summary: "целей проверено и доступно для запуска кампании",
      ready: "Готово",
      blocked: "Заблокировано",
      empty: "Цели продвижения пока не настроены.",
      review: "Проверить цели →",
    },
    create: {
      title: "Создать кампанию продвижения",
      description: "Сначала создайте основу кампании. Затем выберите публикации, подготовьте текст, укажите цели и запустите кампанию из рабочего пространства.",
      name: "Название кампании",
      namePlaceholder: "например, Еженедельный обзор технологий",
      descriptionLabel: "Описание",
      descriptionPlaceholder: "Внутренние заметки, цель, аудитория…",
      draftNote: "Кампании begin as Черновик. No Telegram messages are sent until you explicitly select verified targets and confirm launch.",
      action: "Создать кампанию",
    },
    campaigns: {
      title: "Кампании",
      empty: "Кампаний пока нет.",
      selectTitle: "Выберите кампанию",
      selectDescription: "Откройте кампанию из списка, чтобы подготовить и опубликовать её.",
      markReady: "Отметить готовой",
      backDraft: "Вернуть в черновик",
      deleteAria: "Удалить кампанию {{name}}",
      deliveries: "Доставки",
      succeeded: "Успешно",
      failed: "Ошибка",
      warnings: "Предупреждения",
    },
    posts: {
      addTitle: "Добавить собранную публикацию",
      searchPlaceholder: "Поиск собранных публикаций по каналу, ID или тексту…",
      select: "Выберите собранную публикацию (показано {{count}})",
      aiNote: "AI mode uses prepared copy from Студия ИИ-продвижения or manually entered copy.",
      contentMode: "Режим контента",
      promotionText: "Текст продвижения",
      aiPlaceholder: "Введите здесь подготовленный ИИ текст продвижения.",
      textPlaceholder: "Напишите рекламную версию этой публикации…",
      cta: "Призыв к действию",
      ctaPlaceholder: "Читать далее / Присоединиться к каналу…",
      sourceLink: "Переопределить ссылку источника",
      save: "Сохранить текст",
      originalTitle: "Исходная публикация",
      sourceUnavailable: "Исходная публикация недоступна.",
      preview: "Предпросмотр Telegram",
      copyNotReady: "Текст продвижения ещё не готов.",
      emptyTitle: "В кампании нет публикаций",
      emptyDescription: "Добавьте одну или несколько собранных публикаций перед выбором целей продвижения.",
      editAria: "Редактировать публикацию кампании",
      removeAria: "Удалить публикацию кампании",
    },
    launch: {
      title: "Выберите цели продвижения",
      description: "Можно выбирать только проверенные и включённые цели. Ошибка одной цели не блокирует успешные назначения.",
      verified: "Проверено",
      noTargets: "Целей продвижения пока нет. Super-Admin должен настроить и проверить хотя бы одну цель до запуска кампании.",
      running: "Эта кампания уже выполняется. Возобновление использует исходный набор целей, сохранённый backend.",
      selected_one: "выбрана {{formattedCount}} цель",
      selected_few: "выбрано {{formattedCount}} цели",
      selected_many: "выбрано {{formattedCount}} целей",
      selected_other: "выбрано {{formattedCount}} цели",
      posts_one: "{{formattedCount}} публикация кампании",
      posts_few: "{{formattedCount}} публикации кампании",
      posts_many: "{{formattedCount}} публикаций кампании",
      posts_other: "{{formattedCount}} публикации кампании",
      deliveries: "до {{count}} доставок",
      confirmHint: "Нажмите ещё раз для подтверждения публикации",
      confirm: "Подтвердить запуск",
      launch: "Запустить кампанию",
    },
    delivery: {
      title: "Отчёт о доставке",
      description: "Результаты по каждой цели и журнал повторных попыток.",
      retrySelected: "Повторить выбранные ({{count}})",
      retryAll: "Повторить все неудачные",
      headers: {
        status: "Статус",
        post: "Публикация",
        target: "Цель",
        attempts: "Попытки",
        result: "Результат",
      },
      lastAttempt: "Последняя: {{date}}",
      success: "Опубликовано успешно",
    },
    targets: {
      addTitle: "Добавить цель кампании",
      addDescription: "Добавьте Telegram-канал или группу, куда могут публиковаться кампании. Перед выбором назначения требуется проверка подключения.",
      name: "Название цели",
      namePlaceholder: "Партнёрский новостной канал",
      chatId: "ID Telegram-чата / @username",
      chatIdPlaceholder: "@channel or -100…",
      chatType: "Тип чата",
      publishingBot: "Бот публикации",
      selectBot: "Выберите аккаунт бота",
      disabledSuffix: "отключён",
      credentialMissingSuffix: "нет учётных данных",
      botHelp: "Бот уже должен быть участником/администратором назначения с правом публикации.",
      add: "Добавить цель",
      registerHelp: "Сохраните личный токен бота в разделе «Назначения», затем зарегистрируйте этого бота для своего приватного пространства кампаний.",
      register: "Зарегистрировать моего бота назначения",
      listTitle: "Цели кампаний",
      listDescription: "Эти каналы и группы образуют пул назначений, отображаемый при запуске кампании.",
      summary: "проверено {{verified}} · всего {{total}}",
      ready: "Готово к кампаниям",
      needsVerification: "Требуется проверка",
      connectionError: "Ошибка подключения",
      disabled: "Отключено",
      typeNotVerified: "тип не проверен",
      retest: "Проверить снова",
      test: "Проверить соединение",
      emptyTitle: "Назначения кампаний не настроены",
      emptyDescription: "Добавьте выше один из своих Telegram-каналов или групп, затем проверьте подключение.",
    },
    history: {
      title: "История доставки",
      description: "Завершённые, частично выполненные и неудачные кампании сохраняются в журнале аудита. Откройте кампанию, чтобы просмотреть отдельные попытки доставки.",
      emptyTitle: "Истории доставки пока нет",
      emptyDescription: "Результаты кампаний появятся здесь после первого запуска.",
    },
    feedback: {
      refreshed: "Рабочее пространство продвижения обновлено.",
      loadFailed: "Не удалось загрузить данные продвижения.",
      campaignLoadFailed: "Не удалось загрузить кампанию.",
      nameRequired: "Название кампании обязательно.",
      created: "Кампания продвижения создана.",
      createFailed: "Не удалось создать кампанию.",
      marked: "Кампания переведена в статус «{{status}}».",
      updateFailed: "Не удалось обновить кампанию.",
      deleteConfirm: "Удалить черновую кампанию «{{name}}»?",
      deleted: "Кампания удалена.",
      deleteFailed: "Не удалось удалить кампанию.",
      choosePost: "Сначала выберите собранную публикацию.",
      postAdded: "Публикация добавлена в кампанию продвижения.",
      attachFailed: "Не удалось прикрепить публикацию.",
      modeNeedsText: "Режим {{mode}} требует текста продвижения перед запуском.",
      copySaved: "Текст продвижения сохранён.",
      copySaveFailed: "Не удалось обновить текст продвижения.",
      removePostConfirm: "Удалить эту публикацию из кампании?",
      postRemoved: "Публикация удалена из кампании.",
      removePostFailed: "Не удалось удалить публикацию из кампании.",
      botRegistered: "Сохранённый бот назначения теперь доступен для личных кампаний.",
      botRegisterFailed: "Не удалось зарегистрировать бота назначения для кампаний.",
      targetRequired: "Требуются название цели, ID чата Telegram и аккаунт бота.",
      targetCreated: "Назначение продвижения создано. Проверьте подключение перед использованием в кампании.",
      targetCreateFailed: "Не удалось создать назначение продвижения.",
      targetVerified: "Назначение продвижения проверено и готово к кампаниям.",
      targetVerificationFailed: "Проверка назначения продвижения не удалась.",
      targetEnabled: "Назначение продвижения включено.",
      targetDisabled: "Назначение продвижения отключено.",
      targetUpdateFailed: "Не удалось обновить назначение продвижения.",
      targetDeleteConfirm: "Удалить назначение продвижения «{{name}}»? Если оно требуется для аудита существующей истории доставки, удаление будет запрещено.",
      targetDeleted: "Назначение продвижения удалено.",
      targetDeleteFailed: "Не удалось удалить назначение продвижения.",
      selectTarget: "Выберите хотя бы одну проверенную цель продвижения.",
      delivered: "Кампания продвижения успешно доставлена.",
      deliveryResults: "Кампания завершена с результатами доставки. Просмотрите отчёт ниже.",
      launchFailed: "Не удалось запустить кампанию продвижения.",
      selectFailed: "Выберите неудачные доставки для повторной попытки.",
      retryFinished: "Повторная попытка завершена. Отчёт о доставке обновлён.",
      retryFailed: "Не удалось повторить неудачные доставки.",
      sessionChanged: "Сессия изменилась. Откройте рабочее пространство снова.",
      requestFailed: "Запрос продвижения завершился ошибкой ({{status}}).",
    },
  },
  ai: {
    loading: "Загрузка студии ИИ-продвижения",
    heroEyebrow: "ИИ-движок продвижения",
    heroTitle: "Сгенерировать, проверить и сохранить",
    heroDescription: "Generate promotion-specific copy with the configured Gemini or OpenRouter model. Результатs stay editable and are never published automatically.",
    operationFailed: "Операция ИИ завершилась ошибкой",
    campaignPost: "Публикация кампании",
    campaign: "Кампания",
    selectCampaign: "Выберите кампанию",
    post: "Публикация",
    selectPost: "Выберите публикацию кампании",
    campaignState: "Кампания {{status}} · {{editing}} · роль {{role}}",
    editingEnabled: "Редактирование ИИ включено",
    readOnly: "только чтение после начала публикации",
    generationControls: "Управление генерацией",
    action: "Действие ИИ",
    writingStyle: "Стиль текста",
    outputLanguage: "Язык результата",
    outputLanguagePlaceholder: "Английский",
    extraInstructions: "Дополнительные инструкции",
    instructionsPlaceholder: "Аудитория, акценты, желаемая длина…",
    generate: "Создать: {{action}}",
    backendNote: "Провайдер и API-ключи определяются на backend из текущей конфигурации ИИ. Исходный текст рассматривается как недоверенный материал, а не как инструкции модели.",
    generatedTitle: "Сгенерированный результат",
    generatedDescription: "Проверьте результат перед применением к тексту кампании.",
    generatedPlaceholder: "Здесь появится результат ИИ…",
    apply: "Применить результат",
    editorTitle: "Редактор текста кампании",
    editorDescription: "Этот текст будет сохранён для последующей публикации в Telegram.",
    contentMode: "Режим контента",
    promotionText: "Текст продвижения",
    cta: "Призыв к действию",
    ctaPlaceholder: "Читать далее / Присоединиться к каналу…",
    save: "Сохранить в кампанию",
    preview: "Предпросмотр Telegram",
    previewEmpty: "Выберите публикацию кампании, чтобы просмотреть итоговый текст продвижения.",
    styles: {
      professional: "Профессиональный",
      news: "Новостной",
      educational: "Образовательный",
      friendly: "Дружелюбный",
      casual: "Неформальный",
      marketing: "Маркетинговый",
      viral: "Вирусный",
    },
    actions: {
      teaser: { label: "Тизер", help: "Создайте краткое интригующее вступление без кликбейта." },
      rewrite: { label: "Рекламная переработка", help: "Преобразуйте исходный или текущий черновик в качественный рекламный текст." },
      shorten: { label: "Сократить", help: "Сократите рабочий текст, сохранив ключевые факты." },
      expand: { label: "Расширить", help: "Улучшите структуру и пояснение, не добавляя новых фактов." },
      translate: { label: "Перевести", help: "Переведите точно, сохраняя ссылки, имена и форматирование." },
      cta: { label: "Создать CTA", help: "Создайте один короткий призыв к действию для публикации кампании." },
      hashtags: { label: "Создать хэштеги", help: "Создайте 3–6 релевантных хэштегов Telegram." },
    },
    feedback: {
      selectPost: "Сначала выберите публикацию кампании.",
      editableOnly: "AI generation is available only for Черновик or Готово campaigns.",
      chooseLanguage: "Выберите язык перевода.",
      generated: "{{action}} создано. Проверьте перед применением.",
      generationFailed: "Генерация ИИ не удалась.",
      applied: "Сгенерированный результат применён к редактируемому тексту кампании.",
      editOnly: "Редактировать публикации можно только в кампаниях со статусом «Черновик» или «Готово».",
      modeNeedsText: "Режим {{mode}} требует текста продвижения.",
      saved: "Текст продвижения с помощью ИИ сохранён в кампании.",
      saveFailed: "Не удалось сохранить текст продвижения.",
      loadFailed: "Не удалось загрузить студию ИИ-продвижения.",
      campaignLoadFailed: "Не удалось загрузить кампанию.",
      sessionChanged: "Сессия изменилась. Откройте рабочее пространство снова.",
      requestFailed: "Запрос к ИИ продвижения завершился ошибкой ({{status}}).",
    },
  },
} as const;

export default promotion;
